export const optionsStatusAdvanceComposer = [
  {
    name: "Open",
    value: "open",
    color: "success",
  },
  {
    name: "Closed",
    value: "closed",
    color: "danger",
  },
];
